import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface ViewAllWrapperProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    dataTestId: string
    children: JSX.Element
}

const ViewAllWrapper = memo(({templating, dataTestId, children}: ViewAllWrapperProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName data-testid={dataTestId}>{children}</ComponentName>
        </Suspense>
    )
})

ViewAllWrapper.displayName = "ViewAllWrapper"

export default connect(ViewAllWrapper)
